import {connect} from 'react-redux';
import {IntlProvider} from 'react-intl';

export default connect(
    state => ({
        locale  : state.stolo.i18n.currentLanguage.code,
        messages: state.stolo.i18n.currentLanguage.messages,
        fabrics: state.stolo.i18n.fabrics,
        defaultLocale: "de",
        key: state.stolo.i18n.currentLanguage.locale,
    })
)(IntlProvider);



// WEBPACK FOOTER //
// ./src/components/ConnectedIntlprovider.js